import { FC, useState } from "react";
import { IInputGroup } from "./interface";
import {
  // FormattedInputContainer,
  InputGroupContainer,
} from "./style";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { AiOutlineArrowRight } from "react-icons/ai";
import { TagList } from "../tag-list";
import { CustomToolTip } from "../Tooltip/Index";
import { FormattedInput } from "./format-input";

export const InputGroup: FC<IInputGroup> = ({
  label,
  placeholder,
  type,
  name,
  width,
  handleChange,
  error,
  value,
  disabled,
  addMultipleText,
  multipleText,
  className = "",
  textAreaProps,
  tooltip,
  tooltipText,
  inputAttr,
  amountFormat,
  formatHandleChange,
  inputMode,
  pattern,
}) => {
  // Manages state of opening and closing eye icon in password inputs
  const [showPassword, setShowPassword] = useState<boolean>(false);

  if (tooltipText) {
    tooltip = { ...tooltip!, title: tooltipText };
  }

  return (
    <InputGroupContainer
      password={type === "password" ? true : false}
      width={width}
      error={error ? true : false}
      className={className}
    >
      <figure>
        <small>{label}</small>
        {tooltipText && <CustomToolTip {...tooltip!} className="tooltip" />}
      </figure>

      <div>
        {type !== "textarea" &&
          (amountFormat === true ? (
            <FormattedInput
              {...{
                value,
                placeholder,
                name,
                inputAttr,
                disabled,
                formatHandleChange,
              }}
            />
          ) : (
            <input
              type={
                type !== "password"
                  ? type || "text"
                  : showPassword
                  ? "text"
                  : "password"
              }
              name={name}
              placeholder={placeholder}
              onChange={handleChange}
              id={name}
              value={value}
              disabled={disabled}
              {...inputAttr}
              inputMode={inputMode}
              pattern={pattern}
            />
          ))}
        {type === "textarea" && (
          <textarea
            name={name}
            placeholder={placeholder}
            onChange={handleChange}
            id={name}
            {...textAreaProps}
            value={value}
          />
        )}
        {type === "password" &&
          (!showPassword ? (
            <FiEyeOff
              className="eye-icon"
              onClick={() => {
                setShowPassword(true);
              }}
            />
          ) : (
            <FiEye
              className="eye-icon"
              onClick={() => {
                setShowPassword(false);
              }}
            />
          ))}
        {type === "multiple" && (
          <figure
            className="add-multiple"
            onClick={() => {
              addMultipleText && addMultipleText();
            }}
          >
            <AiOutlineArrowRight />
          </figure>
        )}
      </div>

      {/* When multiple texts are entered and saved on the ui */}
      {multipleText && multipleText?.length > 0 && (
        <TagList tags={multipleText} className="tags" />
      )}

      {error && <small className="error">{error}</small>}
    </InputGroupContainer>
  );
};
